import { Component, HostBinding, Input } from '@angular/core';
import { ThemePalette } from '@angular/material/core';
import { Observable, of } from 'rxjs';

import { ButtonBaseComponent } from '../button-base.component';

/**
 * Icon button component is to manage the action
 */
@Component({
  selector: 'app-button-icon',
  templateUrl: 'button-icon.component.html',
  styleUrls: ['button-icon.component.scss'],
})
export class ButtonIconComponent extends ButtonBaseComponent {
  @HostBinding('style.visibility') visibility = 'visible';

  @Input() vertical: boolean;
  @Input() isShowTitle: Observable<boolean>;
  @Input() visible: string;
  @Input() color: ThemePalette;

  constructor() {
    super();
    this.vertical = false;
    this.isShowTitle = of(true);
    this.color = 'primary';
    this.visible = 'unset';
  }
}
